import { useCallback, useMemo, useState } from 'react';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useBoolean from 'src/hooks/useBoolean';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import DeleteConfirmationModal from './DeleteConfirmationModal';

export default function OcrDelete() {
  const { selectedDocuments, ocrAttachmentList, disableRefresh } = useInvoiceScanManager();
  const { value: deleteModal, setTrue: openDeleteModal, setFalse: closeDeleteModal } = useBoolean();
  const [selectedIds, setSelectedIds] = useState<0[]>([]);
  const includesInProgress = selectedDocuments.some((d) => d.ocrStatus === 'In Progress');

  const { informationMessageList, errorMessageList, isDeleteButtonDisabled } = useMemo(() => {
    const isDeleteButtonDisabled = selectedDocuments.length === 0 || includesInProgress;
    let informationMessageList: string[] = [];
    const errorMessageList: string[] = [];
    if (ocrAttachmentList.length === 0) {
      informationMessageList.push('You have no OCR files in queue to Delete.');
    }
    if (selectedDocuments.length === 0) {
      informationMessageList.push('Please select record(s) to Delete.');
    }
    if (includesInProgress) {
      errorMessageList.push('Please select Failed or Needs Review record(s) to Delete.');
    }
    return {
      isDeleteButtonDisabled,
      informationMessageList,
      errorMessageList,
    };
  }, [includesInProgress, ocrAttachmentList.length, selectedDocuments.length]);

  const handleDeleteModal = useCallback(() => {
    setSelectedIds(selectedDocuments.map((d) => d.attachId));
    disableRefresh();
    openDeleteModal();
  }, [openDeleteModal, selectedDocuments, disableRefresh]);

  return (
    <div>
      <PopUp
        content={
          <div className="m-1 max-w-[300px]">
            <PopUpContentWrapper type="Error" contents={errorMessageList} />
            <PopUpContentWrapper type="Information" contents={informationMessageList} />
          </div>
        }
        show={isDeleteButtonDisabled}
      >
        <Button color="error" onClick={handleDeleteModal} disabled={isDeleteButtonDisabled}>
          Delete
        </Button>
      </PopUp>
      <DeleteConfirmationModal
        canDeleteAndMove={false}
        modalState="delete"
        onClose={closeDeleteModal}
        visible={deleteModal}
        attachmentIds={selectedIds}
      />
    </div>
  );
}
